import React, { ComponentProps, useEffect, useMemo, useState } from 'react';
import { StepProps } from '../../../types/RegistrationJourney';
import {
   Icons,
   LinkifyText,
   Modal,
   replaceKeyWithValue,
   SelectionCardsGroup,
   SelectOption,
   Sizes,
   Stepper,
   useLangContext,
   Variants,
} from 'carrier-fe';
import { REGISTERING_PARTIES, STEPS, SYSTEM_TYPES } from '../../../util/Constants';

type SelectionTileOptions = ComponentProps<typeof SelectionCardsGroup>['options'];

const registeringParties: SelectionTileOptions = [
   {
      label: REGISTERING_PARTIES.HOUSEHOLDER_LABEL,
      value: REGISTERING_PARTIES.HOUSEHOLDER,
      imageSrc: '/Householder.svg',
   },
   {
      label: REGISTERING_PARTIES.INSTALLER_LABEL,
      value: REGISTERING_PARTIES.INSTALLER,
      imageSrc: '/Installer.svg',
   },
];

function Step1({ form, pageLang, loading }: StepProps) {
   const [installerModalOpen, setInstallerModalOpen] = useState(false);
   const [selects, setSelects] = useState<{ [key: string]: SelectionTileOptions }>({
      registering_parties: registeringParties,
   });
   const { crud, fields } = useLangContext();

   const openInstallerModal = (
      value: REGISTERING_PARTIES.HOUSEHOLDER | REGISTERING_PARTIES.INSTALLER
   ) => {
      if (value === REGISTERING_PARTIES.INSTALLER) {
         setInstallerModalOpen(true);
      }
   };

   useEffect(() => {
      setSelects({
         registering_parties: selects?.registering_parties?.map((option) => {
            if (option?.value === REGISTERING_PARTIES.INSTALLER) {
               return {
                  ...option,
                  buttonProps: {
                     onClick: () => openInstallerModal(option?.value as any),
                     label: REGISTERING_PARTIES.INSTALLER_VPLUS_LABEL,
                     variant: Variants.Primary,
                     size: Sizes.Small,
                     position: 'relative',
                     className: 'mt-2',
                  },
               };
            }
            return option;
         }),
      });
   }, []);

   return (
      <Stepper.Step
         loading={loading}
         title={pageLang?.page?.steps?.[STEPS.STEP_2 - 1]?.title || 'Registration Details'}
         description={pageLang?.page?.steps?.[STEPS.STEP_2 - 1]?.description || ''}
      >
         <>
            <SelectionCardsGroup
               noMargin
               options={selects?.registering_parties as any}
               value={form?.store?.registered_by}
               onChange={(value) => {
                  form?.setValues({ registered_by: value as any });
                  form?.setErrors({ registered_by: undefined });
               }}
               errors={form?.errors?.registered_by}
               label={fields?.registered_by || `Who is registering the installation?`}
            />

            <Modal
               confirmText={pageLang?.generic?.householder_benefit_modal?.confirm_text}
               onConfirm={() =>
                  window.open(process.env.REACT_APP_DASHBOARD_URL + '/register', '_blank')
               }
               onClose={() => setInstallerModalOpen(false)}
               closeText={crud?.buttons.cancel.default || 'Cancel'}
               open={installerModalOpen}
               title={
                  pageLang?.generic?.householder_benefit_modal?.title ||
                  'Viessmann Membership Benefits'
               }
            >
               <div className="mb-3">
                  <p className="mb-2">
                     {pageLang?.generic?.householder_benefit_modal?.description}
                  </p>
                  <ul className="list-disc pl-6">
                     {pageLang?.generic?.householder_benefit_modal?.benefits?.map(
                        (benefit: string) => (
                           <li key={benefit} className="mb-1">
                              {benefit}
                           </li>
                        )
                     )}
                  </ul>
                  <LinkifyText
                     text={pageLang?.generic?.householder_benefit_modal?.info_text || ''}
                  />
               </div>
            </Modal>

            {/* Vplus ad */}
               <img
                 onClick={() => {
                   window.open(process.env.REACT_APP_DASHBOARD_URL + '/register', '_blank');
                 }}
                 src="/vplus-ad.png"
                 alt="Vplus"
                 className="w-full mt-4 h-auto mb-2 cursor-pointer"
               />
         </>
      </Stepper.Step>
   );
}

export default Step1;
